import { forwardRef, ReactNode } from 'react';
import classnames from 'classnames';

import styles from './styles.less';

interface Props {
    dash: null | 'green' | 'blue' | 'sky' | 'violet';
    title: string;
    description: string;
    action?: ReactNode;
    imageIdx: 1 | 2 | 3 | 4 | 5;
}

const SectionScreensItem = forwardRef<HTMLDivElement, Props>(({ dash, title, description, action, imageIdx }, ref) => (
    <article className={styles.item} ref={ref}>
        <div className={styles.itemContent}>
            {dash && (
                <div
                    className={classnames(styles.itemDash, {
                        [styles[`item-dash_${dash}`]]: true,
                    })}
                />
            )}
            <p className={styles.itemText}>
                <b className={styles.itemTextBold}>{title}</b> <span>{description}</span>
            </p>
            {action && <div className={styles.itemAction}>{action}</div>}
        </div>
        <div className={classnames(styles.itemImage, [styles[`item-image-${imageIdx}`]])} />
    </article>
));

export default SectionScreensItem;
